var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"id":"Component 55"}},[_c('path',{attrs:{"id":"Icon","d":"M12.75 5.25L9 9L5.25 12.75M5.25 5.25L12.75 12.75","stroke":"#101828","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }